export const autoLoanTag = [
    {
        path:'/car-loans',
        title:'Car Loan Offers in UAE | Best Car Loan in UAE from Top Banks - Soulwallet',
        description:'Looking for Car Loan in UAE? Compare from the best car loans in Dubai to find the best finance for a car with minimum documentation and attractive Interest rates. Apply for a car loan online at Soulwallet!'
    },
    {
        path:'/car-loans/islamic-finance',
        title:'Best Islamic Car Loan in UAE | Islamic Auto Finance in UAE - Soulwallet',
        description:'Looking for the best sharia compliant Islamic car loan in UAE from Top banks?  We can help you with our best auto finance offer that can help you finance your dream car. Apply now!'
    },
    {
        path:'/car-loans/loans-for-non-listed-companies',
        title:'Car Loan for Non-Listed Company Employees from Top Banks in UAE - Soulwallet',
        description:'Looking for a car loan for non listed company employees? We can help you with a wide range of car loans in UAE for non listed companies. Apply for Auto loans without any company listing today!'
    },
    {
        path:'/car-loans/sme-car-loans',
        title:'Business Car Loan in UAE from Top Banks | Best Small Business Car Loan - Soulwallet',
        description:'Choose from a wide range of business car loans in Dubai & entire UAE for SMEs, startups, and more. Our business auto loan from top banks is easy to apply with minimum documentation and attractive Interest rates. Apply now!'
    },
    {
        path:'/car-loans/other-loans',
        title:'Compare and Find the best Car loans',
        description:'Compare and Find the Best Auto loans in the UAE. Find the most suitable personal finance options at Soulwallet.'
    }
]


// WEBPACK FOOTER //
// ./src/components/autoLoans/AutoLoanTag.js